import { NfStatus } from './nf-status.enum';

export interface NfSummaryResponse {
  id: number;
  status: NfStatus;
  operatorEmail: string;
  truckPlate: string;
  truckPlateCountry: string;
  driverName: string;
  driverPhone: string;
  nfNumbers: string[];
  uliNumbers: string[];
  createdOn: string;
  statusChangedOn: string;
}

export interface NfSearchResponse {
  items: NfSummaryResponse[];
  pageNumber: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  size: number;
}
